import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import SubeMerkezi from "@/pages/SubeMerkezi";
import Suspans from "@/pages/Suspans";
import Duplicates from "@/pages/Duplicates";
import Firms from "@/pages/Firms";
import FirmDetail from "@/pages/FirmDetail";
import QuickAdd from "@/pages/QuickAdd";
import AnalizForm from "@/pages/AnalizForm";
import Reports from "@/pages/Reports";
import MapPage from "@/pages/MapPage";
import CargoEntry from "@/pages/CargoEntry";
import CargoList from "@/pages/CargoList";
import Operasyon from "@/pages/Operasyon";
import TirRota from "@/pages/TirRota";
import Hesaplama from "@/pages/Hesaplama";
import Suppliers from "@/pages/Suppliers";
import RecordPage from "@/pages/RecordPage";
import Muhasebe from "@/pages/Muhasebe";
import Tasks from "@/pages/Tasks";
import Settings from "@/pages/Settings";
import DeleteRequests from "@/pages/DeleteRequests";
import SozlesmeAyristir from "@/pages/SozlesmeAyristir";
import WorkRoom from "@/pages/WorkRoom";
import Help from "@/pages/Help";
import TirPlan from "@/pages/TirPlan";
import Vehicles from "@/pages/Vehicles";
import NavlunHakedis from "@/pages/NavlunHakedis";
import Ambarlar from "@/pages/Ambarlar";
import PublicNetwork from "@/pages/PublicNetwork";
import CarrierRegister from "@/pages/CarrierRegister";
import PublicTirPlan from "@/pages/PublicTirPlan";
import GunlukKar from "@/pages/GunlukKar";
import Eslesmeler from "@/pages/Eslesmeler";
import Kasa from "@/pages/Kasa";
import GelenKargo from "@/pages/GelenKargo";
import GelenTir from "@/pages/GelenTir";
import FaturaOnizleme from "@/pages/FaturaOnizleme";
import MutabakatBelge from "@/pages/MutabakatBelge";
import Faturalar from "@/pages/Faturalar";
import GrupPanosu from "@/pages/GrupPanosu";
import SurucuGunSonu from "@/pages/SurucuGunSonu";
import SurucuTeslim from "@/pages/SurucuTeslim";
import Cekler from "@/pages/Cekler";
import OrtakHesap from "@/pages/OrtakHesap";
import CariKargo from "@/pages/CariKargo";

function Protected({ children, adminOnly }) {
  const { user, isAdmin } = useAuth();
  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-950 text-slate-400">
        YÜKLENİYOR...
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function Home() {
  const { user } = useAuth();
  if (user === false) return <Navigate to="/login" replace />;
  return <Protected><Dashboard /></Protected>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Home />} />
      <Route path="/musteriler" element={<Protected><Customers /></Protected>} />
      <Route path="/mukerrer" element={<Protected><Duplicates /></Protected>} />
      <Route path="/firmalar" element={<Protected adminOnly><Firms /></Protected>} />
      <Route path="/firmalar/:id" element={<Protected adminOnly><FirmDetail /></Protected>} />
      <Route path="/silme-onaylari" element={<Protected adminOnly><DeleteRequests /></Protected>} />
      <Route path="/hizli-ekle" element={<Protected><QuickAdd /></Protected>} />
      <Route path="/analiz" element={<Protected><AnalizForm /></Protected>} />
      <Route path="/raporlar" element={<Protected><Reports /></Protected>} />
      <Route path="/harita" element={<Protected><MapPage /></Protected>} />
      <Route path="/kargo-girisi" element={<Protected><CargoEntry /></Protected>} />
      <Route path="/kargolar" element={<Protected><CargoList /></Protected>} />
      <Route path="/kargo-alimi" element={<Protected><Operasyon /></Protected>} />
      <Route path="/alim-ozet" element={<Protected><Operasyon view="ozet" /></Protected>} />
      <Route path="/tir-rota" element={<Protected><TirRota /></Protected>} />
      <Route path="/tir-plan" element={<Protected><TirPlan /></Protected>} />
      <Route path="/araclar" element={<Protected><Vehicles /></Protected>} />
      <Route path="/navlun-hakedis" element={<Protected><NavlunHakedis /></Protected>} />
      <Route path="/gunluk-kar" element={<Protected><GunlukKar /></Protected>} />
      <Route path="/eslesmeler" element={<Protected><Eslesmeler /></Protected>} />
      <Route path="/suspans" element={<Protected><Suspans /></Protected>} />
      <Route path="/kasa" element={<Protected><Kasa /></Protected>} />
      <Route path="/gelen-kargolar" element={<Protected><GelenKargo /></Protected>} />
      <Route path="/gelen-tir/:id" element={<Protected><GelenTir /></Protected>} />
      <Route path="/cekler" element={<Protected><Cekler /></Protected>} />
      <Route path="/ortak-hesap" element={<Protected><OrtakHesap /></Protected>} />
      <Route path="/cari-kargo" element={<Protected><CariKargo /></Protected>} />
      <Route path="/surucu/:token" element={<SurucuTeslim />} />
      <Route path="/fatura-onizleme/:token" element={<FaturaOnizleme />} />
      <Route path="/mutabakat/:token" element={<MutabakatBelge />} />
      <Route path="/faturalar" element={<Protected><Faturalar /></Protected>} />
      <Route path="/sube-merkezi" element={<Protected><SubeMerkezi /></Protected>} />
      <Route path="/grup-panosu" element={<Protected><GrupPanosu /></Protected>} />
      <Route path="/surucu-gun-sonu" element={<Protected><SurucuGunSonu /></Protected>} />
      <Route path="/tir-plan/:id" element={<Protected><TirPlan /></Protected>} />
      <Route path="/sofor" element={<Protected><TirPlan /></Protected>} />
      <Route path="/yukleme/:token" element={<PublicTirPlan />} />
      <Route path="/ag/:firma" element={<PublicNetwork />} />
      <Route path="/nakliyeci-kayit/:firma" element={<CarrierRegister />} />
      <Route path="/ambarlar" element={<Protected><Ambarlar /></Protected>} />
      <Route path="/hesaplama" element={<Protected><Hesaplama /></Protected>} />
      <Route path="/teklifler" element={<Protected><RecordPage title="TEKLİFLER" endpoint="offers" testid="offers" /></Protected>} />
      <Route path="/sozlesmeler" element={<Protected><RecordPage title="SÖZLEŞMELER" endpoint="contracts" testid="contracts" /></Protected>} />
      <Route path="/sozlesme-ayristir" element={<Protected><SozlesmeAyristir /></Protected>} />
      <Route path="/calisma-odasi" element={<Protected><WorkRoom /></Protected>} />
      <Route path="/tedarikci" element={<Protected><Suppliers /></Protected>} />
      <Route path="/muhasebe" element={<Protected><Muhasebe /></Protected>} />
      <Route path="/is-listesi" element={<Protected><Tasks /></Protected>} />
      <Route path="/ayarlar" element={<Protected adminOnly><Settings /></Protected>} />
      <Route path="/yardim" element={<Protected><Help /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" theme="dark" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
